import { render, staticRenderFns } from "./CdnObjectItem.vue?vue&type=template&id=04f1ac4e&scoped=true&"
import script from "./CdnObjectItem.vue?vue&type=script&lang=ts&"
export * from "./CdnObjectItem.vue?vue&type=script&lang=ts&"
import style0 from "./CdnObjectItem.vue?vue&type=style&index=0&id=04f1ac4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_lodash@4.17.21_prettier@3.0.1_vue-template-compiler@2.7.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f1ac4e",
  null
  
)

export default component.exports